import axios from 'axios';

const LANGUAGE_STORAGE_KEY = 'uptime-status-language';

// Decision: Centralizamos la configuracion de Axios.
// Agregamos interceptor para incluir el token JWT automaticamente en cada request.
const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || '/api',
    headers: {
        'Content-Type': 'application/json'
    }
});

export function buildApiUrl(path, queryParams = {}) {
    const baseURL = api.defaults.baseURL || '/api';
    const normalizedBase = baseURL.endsWith('/') ? baseURL : `${baseURL}/`;
    const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
    const url = /^https?:\/\//i.test(normalizedBase)
        ? new URL(normalizedPath, normalizedBase)
        : new URL(normalizedBase, window.location.origin);

    if (!/^https?:\/\//i.test(normalizedBase)) {
        url.pathname = `${url.pathname.replace(/\/$/, '')}/${normalizedPath}`;
    }

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            url.searchParams.set(key, String(value));
        }
    });

    return url.toString();
}

function isAuthRequest(url = '') {
    return url.includes('/auth/login') || url.includes('/auth/register');
}

function isAuthScreen() {
    return window.location.pathname === '/login' || window.location.pathname === '/register';
}

// Interceptor: agregar token JWT a cada request si existe
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    const language = localStorage.getItem(LANGUAGE_STORAGE_KEY);

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    if (language) {
        config.headers['Accept-Language'] = language;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

// Interceptor: manejar errores 401 redirigiendo al login
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (
            error.response &&
            error.response.status === 401 &&
            !isAuthRequest(error.config?.url) &&
            !isAuthScreen()
        ) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;
